import { collectionObj } from "../firebase/fireFuncs";

function getId(length = 18) {
  const chars =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var result = "";
  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}

function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function showImagePreviewWithFileReader(file, target) {
  var fr = new FileReader();
  if (file != null) {
    fr.readAsDataURL(file);
  }

  fr.onload = function (e) {
    var image = this.result ?? "/images/drawable/icon_description.png";
    target.src = image;
  };
}

function forArrayLength(array, func) {
  for (let i = 0; i < array.length; i++) {
    func(array[i]);
  }
}

function makeOption(name, image, func, color) {
  return { name, image, func, color };
}

function getCreationInput(
  type,
  name,
  field,
  hint,
  mandatory,
  payload,
  inputType
) {
  return { type, name, field, hint, mandatory, payload, inputType };
}

function makeSearchArray(id) {
  const strings = [];
  for (let i = 0; i < id.length; i++) {
    const string = id.slice(0, i + 1);
    strings.push(string);
  }
  return strings;
}

function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

function fixPluralType(type) {
  const fixedType =
    type == "problems" ? "problems" : type == "focuss" ? "focuses" : type;
  return fixedType;
}

function calculateAverage(list, field) {
  var score = 0;
  forArrayLength(list, (item) => {
    score += item[field];
  });
  if (list.length == 0) return 0;
  return Math.round(score / list.length);
}

function objectToArray(object, keyName, valueName) {
  const keys = Object.keys(object);
  const values = Object.values(object);
  if (!keyName) {
    return keys.map((key, index) => {
      return { key, value: values[index] };
    });
  } else {
    return keys.map((key, index) => {
      return { [keyName]: key, [valueName]: values[index] };
    });
  }
}

function getTimeDiff(older, newer) {
  const diff = newer - older;
  return {
    seconds: Math.round(diff / 1000),
    minutes: Math.round(diff / 60000),
  };
}

function checkFoundSomething(result) {
  var found = false;
  forArrayLength(objectToArray(result), (kv) => {
    if (kv.value.length > 0) {
      found = true;
      return true;
    }
  });
  return found;
}

function makeFieldObject(field, payload, onClick, hoverDescription) {
  return { field, payload, onClick, hoverDescription };
}

// write a function that takes minutes and return either minutes hours days weeks or months based if a value is over 1
function getTimeString(minutes) {
  const timeObj = {
    minutes: 0,
    hours: 0,
    days: 0,
    weeks: 0,
    months: 0,
  };

  timeObj.minutes = minutes;
  if (timeObj.minutes >= 60) {
    timeObj.hours = Math.floor(timeObj.minutes / 60);
  }
  if (timeObj.hours >= 24) {
    timeObj.days = Math.floor(timeObj.hours / 24);
    timeObj.hours = timeObj.hours % 24;
  }
  if (timeObj.days >= 7) {
    timeObj.weeks = Math.floor(timeObj.days / 7);
    timeObj.days = timeObj.days % 7;
  }
  if (timeObj.weeks >= 4) {
    timeObj.months = Math.floor(timeObj.weeks / 4);
    timeObj.weeks = timeObj.weeks % 4;
  }
  const array = objectToArray(timeObj).reverse();
  var found = { value: 0, key: "minutes" };
  for (let i = 0; i < array.length; i++) {
    if (array[i].value >= 1) {
      found = { value: array[i].value, key: array[i].key };
      break;
    }
  }
  const text = `${found.value} ${
    found.value == 1 ? found.key.slice(0, -1) : found.key
  }`;
  return { found, text };
}

function getValueAverage(objects, field) {
  var total = 0;
  forArrayLength(objects, (object) => {
    total += object[field];
  });
  if (objects.length > 0) return Math.round(total / objects.length);
  else return 0;
}

function getAverageFromRatingObject(ratingObject, precision) {
  const KVarray = objectToArray(ratingObject);
  var unit = 0;
  var ratings = 0;
  forArrayLength(KVarray, (kv) => {
    ratings += kv.key * kv.value;
    unit += kv.value;
  });
  if (unit <= 0) return 0;
  else return round(ratings / unit, precision);
}

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

function getBoxTypeNames(boxTypes) {
  const names = [];
  forArrayLength(objectToArray(boxTypes), (boxType) => {
    names.push(boxType.value.names.plural);
  });
  return names;
}

function addPropertyToGeneralObject(boxType, setGeneralObjects) {
  const localGeneral =
    JSON.parse(localStorage.getItem("general")) ?? collectionObj.general;
  const localProperty = localGeneral[boxType];
  console.log("localProperty  -", localProperty);
  if (localProperty == undefined) {
    localGeneral[boxType] = [];
    localStorage.setItem("general", JSON.stringify(localGeneral));
    console.log("localGeneral - ", localGeneral, " | boxType - ", boxType);
    setGeneralObjects(localGeneral);
  }
}

export {
  addPropertyToGeneralObject,
  getBoxTypeNames,
  round,
  getAverageFromRatingObject,
  getValueAverage,
  getTimeString,
  makeFieldObject,
  checkFoundSomething,
  getTimeDiff,
  objectToArray,
  calculateAverage,
  fixPluralType,
  timeSince,
  makeSearchArray,
  getId,
  clamp,
  showImagePreviewWithFileReader,
  forArrayLength,
  makeOption,
  getCreationInput,
};
